import { AbsoluteSpinner } from './AbsoluteSpinner';

type TProps = {
  overlay?: boolean;
  className?: string;
};

export const AbsoluteSmallSpinner = ({ overlay, className }: TProps) => (
  <AbsoluteSpinner overlay={overlay} className={[className, '[&_svg]:!w-5'].filter(Boolean).join(' ')} />
);
